import React from "react";
import { Row, Col, Input } from "reactstrap";
import { STATUS_OPTIONS, DATE_PLACEHOLDER, kecamatanOptions, perihalOptions } from "./OptionsFilter";

const Filters = ({ filters, user, kecamatanList = [], userOptions = [], perihalOptions = [], onChange, desaOptions = [] }) => {
  
  // Gunakan kecamatanList jika ada, jika tidak gunakan keys dari kecamatanOptions
  const kecamatanOptionsList = kecamatanList.length > 0 
    ? kecamatanList 
    : Object.keys(kecamatanOptions);
  
    const kelurahanOptionsList = desaOptions.length > 0
    ? desaOptions
    : [];

  // Gunakan perihalOptions dari props jika ada, jika tidak gunakan default
  const perihalOptionsList = perihalOptions.length > 0 
    ? perihalOptions 
    : [
        "Rehab Rumah Tidak Layak Huni",
        "Pembangunan Rumah Layak Huni",
        "Meteran Listrik 900 VA",
        // "Bangun Baru",
        // "Perbaikan Sanitasi",
        // "Bantuan Material"
      ];

  return (
    <Row className="mb-4">
      <Col xs={12}>
        <div className="filters-container p-3 bg-light rounded border">
          <Row>
            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="searchName" className="form-label fw-bold">Cari Nama Pemohon:</label>
                <input
                  type="text"
                  id="searchName"
                  name="searchName"
                  className="form-control"
                  value={filters.searchName || ""}
                  onChange={onChange}
                  placeholder="Masukkan nama lengkap"
                />
              </div>
            </Col>
            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="searchNameKK" className="form-label fw-bold">Cari Nama Kepala Keluarga:</label>
                <input
                  type="text"
                  id="searchNameKK"
                  name="searchNameKK"
                  className="form-control"
                  value={filters.searchNameKK || ""}
                  onChange={onChange}
                  placeholder="Masukkan Kepala Keluarga"
                />
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="searchNik" className="form-label fw-bold">Cari NIK:</label>
                <input
                  type="text"
                  id="searchNik"
                  name="searchNik"
                  className="form-control"
                  value={filters.searchNik || ""}
                  onChange={onChange}
                  placeholder="Masukkan NIK"
                />
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="searchNoKK" className="form-label fw-bold">Cari No KK:</label>
                <input
                  type="text"
                  id="searchNoKK"
                  name="searchNoKK"
                  className="form-control"
                  value={filters.searchNoKK || ""}
                  onChange={onChange}
                  placeholder="Masukkan Nomor KK"
                />
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="status" className="form-label fw-bold">Status:</label>
                <select
                  id="status"
                  name="status"
                  className="form-select"
                  value={filters.status || ""}
                  onChange={onChange}
                >
                  <option value="">Pilih Status</option>
                  <option value="Semua Status">Semua Status</option>
                  {STATUS_OPTIONS.map((status) => (
                    <option key={status} value={status}>{status}</option>
                  ))}
                </select>
              </div>
            </Col>
          
            <Col md={4} className="mb-3">
              <div className="form-group">
                <label className="form-label fw-bold">Kecamatan:</label>
                <Input
                  type="select"
                  name="kecamatan"
                  id="kecamatan"
                  value={filters.kecamatan || ""}
                  onChange={onChange}
                >
                  <option value="">Pilih Kecamatan</option>
                  <option value="Semua Kecamatan">Semua Kecamatan</option>
                  {kecamatanOptionsList.map(kec => (
                    <option key={kec} value={kec}>{kec}</option>
                  ))}
                </Input>
              </div>
            </Col>
             <Col md={4} className="mb-3">
              <div className="form-group">
                <label className="form-label fw-bold">Kelurahan/Desa:</label>
                <Input
                  type="select"
                  name="kelurahan"
                  id="kelurahan"
                  value={filters.kelurahan || ""}
                  onChange={onChange}
                >
                  <option value="">Pilih Kelurahan</option>
                  <option value="Semua Kelurahan">Semua Kelurahan</option>
                  {kelurahanOptionsList.map(kec => (
                    <option key={kec} value={kec}>{kec}</option>
                  ))}
                </Input>
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <div className="form-group">
                <label className="form-label fw-bold">Tahun:</label>
                <Input
                  type="select"
                  name="tahun"
                  id="tahun"
                  value={filters.tahun || ""}
                  onChange={onChange}
                >
                  <option value="">Pilih Tahun</option>
                  <option value="Semua Tahun">Semua Tahun</option>
                  {Array.from({length: 10}, (_, i) => new Date().getFullYear() - i).map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </Input>
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="searchAlamat" className="form-label fw-bold">Cari Alamat:</label>
                <input
                  type="text"
                  id="searchAlamat"
                  name="searchAlamat"
                  className="form-control"
                  value={filters.searchAlamat || ""}
                  onChange={onChange}
                  placeholder="Masukkan alamat"
                />
              </div>
            </Col>

            {/* Filter perihal */}
            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="perihal" className="form-label fw-bold">Perihal/Usulan:</label>
                <select
                  id="perihal"
                  name="perihal"
                  className="form-select"
                  value={filters.perihal || ""}
                  onChange={onChange}
                >
                  <option value="">Pilih Perihal</option>
                  <option value="Semua Perihal">Semua Perihal</option>
                  {perihalOptionsList.map((perihal) => (
                    <option key={perihal} value={perihal}>
                      {perihal}
                    </option>
                  ))}
                </select>
              </div>
            </Col>

            {/* FILTER TANGGAL DITERIMA PER HARI */}
            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="tanggalDiterima" className="form-label fw-bold">Tanggal Diterima:</label> {/* (Per Hari) */}
                <input
                  type="date"
                  id="tanggalDiterima"
                  name="tanggalDiterima"
                  className="form-control"
                  value={filters.tanggalDiterima || ""}
                  onChange={onChange}
                />
              </div>
            </Col>

            {/* FILTER RANGE TANGGAL DITERIMA */}
            {/* <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="tanggalMulaiDiterima" className="form-label fw-bold">Tanggal Diterima (Dari):</label>
                <input
                  type="date"
                  id="tanggalMulaiDiterima"
                  name="tanggalMulaiDiterima"
                  className="form-control"
                  value={filters.tanggalMulaiDiterima || ""}
                  onChange={onChange}
                />
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="tanggalSelesaiDiterima" className="form-label fw-bold">Tanggal Diterima (Sampai):</label>
                <input
                  type="date"
                  id="tanggalSelesaiDiterima"
                  name="tanggalSelesaiDiterima"
                  className="form-control"
                  value={filters.tanggalSelesaiDiterima || ""}
                  onChange={onChange}
                />
              </div>
            </Col> */}

            {/* FILTER TANGGAL SURAT PER HARI */}
            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="tanggalSurat" className="form-label fw-bold">Tanggal Surat</label> {/* (Per Hari) */}
                <input
                  type="date"
                  id="tanggalSurat"
                  name="tanggalSurat"
                  className="form-control"
                  value={filters.tanggalSurat || ""}
                  onChange={onChange}
                />
              </div>
            </Col>

            {/* FILTER RANGE TANGGAL SURAT */}
            {/* <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="tanggalMulaiSurat" className="form-label fw-bold">Tanggal Surat (Dari):</label>
                <input
                  type="date"
                  id="tanggalMulaiSurat"
                  name="tanggalMulaiSurat"
                  className="form-control"
                  value={filters.tanggalMulaiSurat || ""}
                  onChange={onChange}
                />
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="tanggalSelesaiSurat" className="form-label fw-bold">Tanggal Surat (Sampai):</label>
                <input
                  type="date"
                  id="tanggalSelesaiSurat"
                  name="tanggalSelesaiSurat"
                  className="form-control"
                  value={filters.tanggalSelesaiSurat || ""}
                  onChange={onChange}
                />
              </div>
            </Col> */}

            {user && user.role === "admin" && (
              <Col md={4} className="mb-3">
                <div className="form-group">
                  <label htmlFor="user" className="form-label fw-bold">Di Input Oleh:</label>
                  <select
                    id="user"
                    name="user"
                    className="form-select"
                    value={filters.user || ""}
                    onChange={onChange}
                  >
                    <option value="">Pilih User</option>
                    <option value="Semua User">Semua User</option>
                    {userOptions.map((userOption) => (
                      <option key={userOption.id} value={userOption.username}>
                        {userOption.username}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default Filters;